import { render } from "./VersionView.vue?vue&type=template&id=06c14273&scoped=true"
import script from "./VersionView.vue?vue&type=script&lang=js"
export * from "./VersionView.vue?vue&type=script&lang=js"

import "./VersionView.vue?vue&type=style&index=0&id=06c14273&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c14273"]])

export default __exports__